(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["studio-product-buying"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('studio-product-shortcut')) {
    customElements.define('studio-product-shortcut', class extends HTMLElement {
      connectedCallback() {
        this.setup = () => {
          this.form = document.getElementById(this.dataset.formId);
          this.submit = this.form?.querySelector('button[name="add"]');
          this.proxy = this.querySelector('[data-studio-shortcut-button]');
          this.price = document.getElementById(`price-${this.dataset.sectionId}`);
          if (!this.form || !this.submit || !this.proxy) return;
          this.sync = () => {
            const busy = this.submit.getAttribute('aria-disabled') === 'true' || this.submit.classList.contains('loading');
            this.proxy.disabled = this.submit.disabled || busy;
            this.proxy.textContent = busy ? this.dataset.busyLabel : (this.submit.querySelector('span')?.textContent || this.submit.textContent).trim();
            this.proxy.setAttribute('aria-busy', String(busy));
            const currentPrice = this.price?.querySelector('.price--on-sale .price__sale .price-item--sale') || this.price?.querySelector('.price__regular .price-item--regular');
            if (currentPrice) this.querySelector('[data-studio-shortcut-price]').textContent = currentPrice.textContent.trim();
          };
          this.activate = () => {
            this.sync();
            if (!this.proxy.disabled) this.submit.click();
          };
          this.proxy.addEventListener('click', this.activate);
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(this.submit, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
          if (this.price) this.observer.observe(this.price, { childList: true, subtree: true, attributes: true });
          this.errorBox = this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
          if (this.errorBox) {
            this.errorObserver = new MutationObserver(() => {
              if (!this.errorBox.hidden && this.errorBox.textContent.trim()) {
                this.errorBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
              }
            });
            this.errorObserver.observe(this.errorBox, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
          }
          this.visibilityObserver = new IntersectionObserver(([entry]) => {
            this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
          });
          this.visibilityObserver.observe(this.submit);
          this.sync();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.setup, { once: true });
        else this.setup();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.setup);
        this.proxy?.removeEventListener('click', this.activate);
        this.observer?.disconnect();
        this.errorObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
